import BaseModel from "../base/BaseModel.model";
import User from '../security/user.model';
import PorposalMemberEffort from './porposalMemberEffort.model';

export default class ProposalMember extends BaseModel {
  public hasUser?: boolean;
  public memberTypeId?: number | null;
  public userId?: number | null;
  public porposalId?: number | null;
  public fullName?:string | null;
  public opendKey?:string;
  public user?:User | null;
  public timeToDedicateThisproject:number;
  public hourWorkToWeekend?:number| null;
  public hoursStrippedByActivity:number;
  public additionalHoursForTheProject:number;
  public totalHoursThatYouWillSpend:number;
  public percentageOfHourlyActivityPerWeek:number;
  public proposalMemberEfforts:Array<PorposalMemberEffort> = [];
  public haveOtherStep:boolean;
  public carrerCode:string|null;
  public isOpend:boolean;
  public showForPutCode:boolean;
  constructor() {
    super();
    this.init();
  }
  init() {
      this.hasUser = false;
      this.opendKey = "";
      this.isOpend = false;
      this.memberTypeId = null;
      this.userId = null;
      this.porposalId = null;
      this.carrerCode = "";
      this.haveOtherStep = false;
      this.showForPutCode = false;
      this.fullName = null;
      this.timeToDedicateThisproject = null;
      this.hourWorkToWeekend = null;
      this.user = null;
      this.hoursStrippedByActivity = null;
    this.proposalMemberEfforts = [];
    this.additionalHoursForTheProject = null;
    this.totalHoursThatYouWillSpend = null;
    this.percentageOfHourlyActivityPerWeek = null;

  }
}
